import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

function Aperture(props) {
    const {store, width, height, color, downhill} = props;

    const points = downhill ? `M 0,0 ${width},${height} V 0 Z` : `M ${width},0 0,${height} V 0 Z`;
    return (
        <svg className="Aperture" width={width} height={height}>
            <path fill={color} d={points}/>
        </svg>
    );
}
Aperture.defaultProps = {
    width: 800,
    height: 100,
    color: '#ffffff',
    downhill: false
};
export default observer(Aperture);
